// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.offline-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-window {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  padding: 40px;
  max-width: 300px;
  width: 90vw;
  max-height: 90vh;
  overflow: auto;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.consumerxlogo {
  width: 10vw;
  max-width: 120px;
}

.grid-message {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  margin: 20px 0;
}

.warning-icon {
  font-size: 48px;
  color: #0CAD99;
  text-align: center;
}

.message-text {
  font-size: 20px;
  padding: 0 10px;
  color: #111;
}

.sub-message {
  font-size: 16px;
  color: #666;
}

.report-error-link {
  margin-top: 20px;
  color: #888;
  text-decoration: underline;
  font-size: 14px;
  cursor: pointer;
}

.report-error-link:hover {
  color: #333;
}`, "",{"version":3,"sources":["webpack://./src/theme/fonts.scss","webpack://./src/app/shared/toolbox/offline-modal/offline-modal.component.scss","webpack://./src/theme/variables.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACCF;ADEA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ACAF;ADGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACDF;ADIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ACFF;ADKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACHF;ADMA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ACJF;ADOA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACLF;ADQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACNF;ADSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACPF;ADUA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACRF;ADWA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ACTF;ADYA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACVF;ADaA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;ACXF;ADcA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;ACZF;ADeA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACbF;ADgBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACdF;ADiBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ACfF;ADkBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AChBF;ACpGA;;;;;uBAAA;ADLA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,+BAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAiHF;;AA9GA;EACE,gBAAA;EACA,mBAAA;EACA,2CAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AAiHF;;AA9GA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAiHF;;AA9GA;EACE,WAAA;EACA,gBAAA;AAiHF;;AA9GA;EACE,aAAA;EACA,mCAAA;EACA,mBAAA;EACA,cAAA;AAiHF;;AA9GA;EACE,eAAA;EACA,cClCW;EDmCX,kBAAA;AAiHF;;AA9GA;EACE,eAAA;EACA,eAAA;EACA,WAAA;AAiHF;;AA9GA;EACE,eAAA;EACA,WAAA;AAiHF;;AA9GA;EACE,gBAAA;EACA,WAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA;AAiHF;;AA9GA;EACE,WAAA;AAiHF","sourcesContent":["@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import \"variables\";\n\n.offline-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.85);\n  z-index: 9999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal-window {\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);\n  padding: 40px;\n  max-width: 300px;\n  width: 90vw;\n  max-height: 90vh;\n  overflow: auto;\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n.consumerxlogo {\n  width: 10vw;\n  max-width: 120px;\n}\n\n.grid-message {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  margin: 20px 0;\n}\n\n.warning-icon {\n  font-size: 48px;\n  color: $accent-btn;\n  text-align: center;\n}\n\n.message-text {\n  font-size: 20px;\n  padding: 0 10px;\n  color: #111;\n}\n\n.sub-message {\n  font-size: 16px;\n  color: #666;\n}\n\n.report-error-link {\n  margin-top: 20px;\n  color: #888;\n  text-decoration: underline;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.report-error-link:hover {\n  color: #333;\n}\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
